/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_WorkersInputs */

const en_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workers`)
};

const ar_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العمال`)
};

const bn_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়ার্কার`)
};

const de_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeiter`)
};

const es_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajadores`)
};

const fr_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travailleurs`)
};

const pt_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhadores`)
};

const zh_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工人`)
};

const tr_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşçiler`)
};

const ru_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочие`)
};

const pl_svchip_workers = /** @type {(inputs: Svchip_WorkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracownicy`)
};

/**
* | output |
* | --- |
* | "Workers" |
*
* @param {Svchip_WorkersInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_workers = /** @type {((inputs?: Svchip_WorkersInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_WorkersInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_workers(inputs)
	if (locale === "bn") return bn_svchip_workers(inputs)
	if (locale === "de") return de_svchip_workers(inputs)
	if (locale === "es") return es_svchip_workers(inputs)
	if (locale === "fr") return fr_svchip_workers(inputs)
	if (locale === "pt") return pt_svchip_workers(inputs)
	if (locale === "zh") return zh_svchip_workers(inputs)
	if (locale === "tr") return tr_svchip_workers(inputs)
	if (locale === "ru") return ru_svchip_workers(inputs)
	if (locale === "pl") return pl_svchip_workers(inputs)
	return en_svchip_workers(inputs)
});